import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";

import { DocumentationPage } from "~/pages/admin-panel";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/admin-panel/documentation")({
  head: defineHead({
    titleT: Tk.DOCUMENTATION,
  }),
  component: DocumentationPage,
});
